import { DetectedOperatingSystemState, DetectedOperatingSystem } from '../../../shared/types/types';

export const initialOperatingSystemContextState: DetectedOperatingSystemState = {
  detectedOperatingSystem: 'Pending',
  setDetectedOperatingSystem: (() => {}),
};

export const pendingOperatingSystemState: DetectedOperatingSystem = 'Pending';
